import { render, staticRenderFns } from "./QuestionMatchCheckbox.vue?vue&type=template&id=1b377c69&scoped=true&"
import script from "./QuestionMatchCheckbox.vue?vue&type=script&lang=js&"
export * from "./QuestionMatchCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b377c69",
  null
  
)

export default component.exports